var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cursor-latlng" }, [
    _c("span", { staticClass: "cursor-latlng__text" }, [
      _vm._v(_vm._s(_vm.latlng_text))
    ]),
    _vm._v(" "),
    _c("span", { ref: "map-scale", staticClass: "map-scale" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }